import { render, staticRenderFns } from "./PreviousOrnaWorkExp.vue?vue&type=template&id=2a5c8f7f&scoped=true"
import script from "./PreviousOrnaWorkExp.vue?vue&type=script&lang=js"
export * from "./PreviousOrnaWorkExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c8f7f",
  null
  
)

export default component.exports